export default "__VITE_ASSET__BBtaeSYQ__"